module.exports = __webpack_public_path__ + "static/media/SPAL.df40c03a.png";